module.exports = __webpack_public_path__ + "static/media/benfica.a8bf00c1.webp";